define.alias("ember-composable-helpers/helpers/pipe-action", "preview-grid/helpers/pipe-action");